import {
  SET_HAS_NEW_NOTIFICATION,
  SET_ARE_NOTIFICATIONS_PAUSED,
  SET_UNREAD_NOTIFICATIONS_COUNT,
} from "./types";

export const setHasNewNotification = hasNewNotification => {
  return { type: SET_HAS_NEW_NOTIFICATION, payload: hasNewNotification };
};

export const setAreNotificationsPaused = arePaused => {
  return { type: SET_ARE_NOTIFICATIONS_PAUSED, payload: arePaused };
};

export const setUnreadNotificationsCount = unreadCount => {
  return { type: SET_UNREAD_NOTIFICATIONS_COUNT, payload: unreadCount };
};
